// hooks/shared/useGlobalUser.ts

import { coreApi } from "@features/core/api";
import { UserProfile } from "@features/auth/types";
import { useSmartQuery } from "@shared/api/queries/hooks";
import { QueryKeyFactory } from "@shared/api/queries/queryKeyFactory";
import { useTenantId } from "@shared/selectors/globalSelectors";
import { Utility } from "@features/core/types";

const CACHED_PROFILE_KEY = "utility";

export const useGlobalUtility = () => {
  const queryKey = QueryKeyFactory.global.utilities.selected();
  const tenantId = useTenantId();
  return useSmartQuery<Utility>(
    queryKey,
    async () => {
      // Check localStorage cache
      const stored = localStorage.getItem(CACHED_PROFILE_KEY);
      if (stored) {
        const parsed = JSON.parse(stored) as any;
                console.log("Utility from localStorage:", parsed);

        return parsed;
      }

      // Fallback to API
      const profile = await coreApi.getUtility(tenantId);
      localStorage.setItem(CACHED_PROFILE_KEY, JSON.stringify(profile));
                      console.log("Utility from API:", profile);

      return profile;
    },
   
  );
};

